import { isPostTheme, KIT_SLOTS } from 'fym-shared/src/music24/assetKinds';
import type { CatalogItem, GetReleaseKitResponse } from '../../../../redux/api/fymAPI.types';
import { buildRevisionCards } from './assets/revisionCards';
import { parseReleaseTab, ReleaseTab } from './releaseTabProps';

/**
 * The figures of the release tabs (design assets-rethink b1): "Kit 9 / 10" (made slots of all
 * slots, fym-shared `KIT_SLOTS`) and "Posts 12" (the post files of the song with a ready file).
 * Pure, so it is tested without React.
 */
export function releaseTabFigures(
  item: Pick<CatalogItem, 'artworkUrl' | 'artworkFile'>,
  release: Pick<GetReleaseKitResponse, 'assets' | 'newest' | 'reels'> | undefined
): { kit: string | null; posts: number | null } {
  if (release === undefined) {
    return { kit: null, posts: null };
  }
  const readyThemes = new Set(release.assets.filter((asset) => asset.status === 'ready').map((asset) => asset.themeId));
  const hasCover = item.artworkUrl !== null || item.artworkFile !== null;
  const made = KIT_SLOTS.filter((slot) => (slot.themeId === null ? hasCover : readyThemes.has(slot.themeId))).length;
  const cards = buildRevisionCards({ assets: release.assets, newest: release.newest, reels: release.reels });
  const posts = cards.filter(
    (card) =>
      isPostTheme(card.themeId) && (card.state === 'ready' || card.readyAsset !== null || card.readyReel !== null)
  ).length;
  return { kit: `${made} / ${KIT_SLOTS.length}`, posts };
}

/**
 * The open tab. `focus=aiReel` opens Posts (an AI reel is a post file). The old `tab=assets` opens
 * Kit, or Posts when its `asset` is a post file of the song (design assets-rethink d1: a link
 * redirects by the kind of the file). An asset that the answer does not hold (an old revision)
 * opens Kit; the Kit tab drops a value it cannot show.
 */
export function resolveReleaseTab(input: {
  tab: string | undefined | null;
  hasFocus: boolean;
  asset: string | undefined | null;
  release: Pick<GetReleaseKitResponse, 'assets' | 'newest' | 'reels'> | undefined;
}): ReleaseTab {
  if (input.hasFocus) {
    return 'posts';
  }
  const tab = parseReleaseTab(input.tab);
  if (input.tab !== 'assets' || input.asset === undefined || input.asset === null || input.asset === '') {
    return tab;
  }
  const uuid = input.asset;
  const { release } = input;
  if (release === undefined) {
    return tab;
  }
  if (release.reels.some((reel) => reel.uuid === uuid)) {
    return 'posts';
  }
  const asset = [...release.assets, ...(release.newest ?? [])].find((one) => one.uuid === uuid);
  return asset !== undefined && isPostTheme(asset.themeId) ? 'posts' : 'kit';
}
